/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
/* eslint-disable max-len */
import { AngularFireAuth } from '@angular/fire/auth';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { NotificationsService } from '../services/notifications.service';
import { AngularFireDatabase } from '@angular/fire/database';
import { BehaviorSubject } from 'rxjs';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/storage';
import 'firebase/firestore';

@Injectable({
    providedIn: 'root'
})

export class AuthService {

    currentAccount: BehaviorSubject<any> = new BehaviorSubject(localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : undefined); // Save logged in user data
    uid;
    id;
    currentUser;
    firstConnect = true;
    unsub1;
    storage = firebase.storage();
    isLoggingOut = false; // Flag to prevent re-authentication during logout

    constructor(
        public firestore: AngularFirestore,
        public database: AngularFireDatabase,
        public auth: AngularFireAuth,
        public route: ActivatedRoute,
        public toastController: ToastController,
        public navController: NavController,
        public modalController: ModalController,
        public notificationsService: NotificationsService,
    ) {
        this.initiateAuth();
    }


    async initiateAuth() {
        this.auth.authState.subscribe(async user => {
            console.log('user', user);
            if (user && !this.isLoggingOut) {
                console.log('onAuthStateChanged', user);
                this.getUser(user.uid).then((currentUser) => {
                    this.currentUser = currentUser;
                    console.log('onAuthStateChangedImportant', this.currentUser);
                    if (this.currentUser) {
                        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
                        this.currentAccount.next(this.currentUser);
                        this.getUserSubscribtion(this.currentUser.id);
                        this.checkUserStatus();
                    } else {
                        this.createUserAccount(user);
                    }
                });
            } else if (!user) {
                // Only clear data if not in the middle of logout process
                if (!this.isLoggingOut) {
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('lastActiveTimestamp');
                    localStorage.removeItem('status');
                    this.navController.navigateRoot(['/login']);
                    this.currentAccount.next(undefined);
                    this.uid = undefined;
                    this.id = undefined;
                    this.currentUser = undefined;
                }
                // Reset the logout flag
                this.isLoggingOut = false;
            }
        });
    }

    get isLoggedIn(): boolean {
        const user = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : undefined;
        return user ? true : false;
    }

    async getUser(uid) {
        return new Promise(async (resolve, reject) => {
            let data;
            const user = await this.firestore.collection('accounts', ref => ref.where('uid', '==', uid).limit(1)).get().toPromise();
            user.forEach(async docRef => {
                data = docRef.data();
                data.id = docRef.id;
            });
            resolve(data);
        });
    }

    async createUserAccount(user) {
        const displayName = user.displayName || user.email?.split('@')[0] || 'User';
        const newUser = {
            displayName: displayName,
            displayNameLower: displayName.toLowerCase(),
            email: user.email,
            uid: user.uid,
        };
        console.log(newUser);
        
        try {
            const currentUserDoc = await this.firestore.collection('accounts').add({
                ...newUser,
            });
            
            console.log(currentUserDoc);
            this.currentUser = await this.getUserById(currentUserDoc.id);
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
            this.currentAccount.next(this.currentUser);
            this.getUserSubscribtion(this.currentUser.id);
            this.checkUserStatus();
        } catch (error) {
            console.error('Error creating user account:', error);
            this.presentToast('Failed to create account. Please try again.');
        }
    }

    async getUserById(id) {
        const docSnap = await this.firestore.collection('accounts').doc(id).get().toPromise();
        if (docSnap.exists) {
            const account: any = { id: docSnap.id, ...((docSnap.data() as any) || {}) };
            return account;
        }
        return undefined;
    }

    getUserByRef(refCode) {
        return new Promise(async (resolve, reject) => {
            let data;
            const user = await this.firestore.collection('accounts', ref => ref.where('refCode', '==', refCode).limit(1)).get().toPromise();
            user.forEach(async docRef => {
                data = docRef.data();
                data.id = docRef.id;
            });
            return resolve(data);
        });
    }

    getUserByPhone(phone) {
        return new Promise(async (resolve, reject) => {
            let data;
            const user = await this.firestore.collection('accounts', ref => ref.where('phone', '==', phone).limit(1)).get().toPromise();
            user.forEach(async docRef => {
                data = docRef.data();
                data.id = docRef.id;
            });
            return resolve(data);
        });
    }

    private async getUserSubscribtion(id) {
        if (this?.unsub1?.unsubscribe) {
            this.unsub1.unsubscribe();
        }
        // eslint-disable-next-line @typescript-eslint/no-shadow
        this.unsub1 = this.firestore.collection('accounts').doc(id).snapshotChanges().subscribe(async (doc) => {
            console.log('Current data: ', doc.payload.data());
            this.currentUser = { id: doc.payload.id, ...(doc.payload.data() as any) };
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
            this.currentAccount.next(this.currentUser);
        });
    }

    checkUserStatus() {
        const connectedRef = this.database.object('.info/connected');
        connectedRef.valueChanges().subscribe((snap) => {
            if (snap === true) {
                console.log('connected');
                this.firstConnect = false;
                this.updateStatus('online');
            } else {
                if (this.firstConnect === false) {
                    console.log('not connected');
                    this.updateStatus('offline');
                }
            }
        });
    }

    async updateStatus(status) {
        let user;
        const userRef = await this.firestore.collection('accounts', ref => ref.where('uid', '==', this.currentUser?.uid).limit(1)).get().toPromise();
        userRef.forEach(docRef => {
            user = docRef.data();
            user.id = docRef.id;
        });
        if (user) {
            this.currentUser = user;
            const lastActiveTimestamp = status !== 'online' || !localStorage.getItem('lastActiveTimestamp') ? Date.now() : new Date(localStorage.getItem('lastActiveTimestamp'));
            this.firestore.collection('accounts').doc(user.id).update({
                status,
                lastActiveTimestamp,
            }).then(() => {
                localStorage.setItem('status', status);
                localStorage.setItem('lastActiveTimestamp', new Date(lastActiveTimestamp).toISOString());
            });
        }
    }

    async connect(connection, userAccount) {
        const connect = {
            users: [this.currentUser.id, userAccount.id],
            timestamp: new Date(),
            status: 'pending',
            type: 'connection',
            requestedBy: this.currentUser.id,
            requestedTo: userAccount.id,
        };
        console.log('connect', connect);
        if (connection && connection.id) {
            this.disconnect(connection, userAccount);
            this.firestore.collection('connections').doc(connection.id).update(connect).then(() => {
                window.dispatchEvent(new CustomEvent('ledger-update', {
                    detail: { user: this.currentUser.id, message: 'Coins for Connection!', value: -1 }
                  }));
                this.presentToast('Connection Requested!');
                this.notificationsService.sendNotification(this.currentUser.displayName, 'Connection Requested', {
                    notificationToken: userAccount.notificationToken,
                    type: 'connection',
                    by: this.currentUser.id,
                    to: userAccount.id,
                    redirectURL: '/profile/' + this.currentUser.uid
                }, userAccount.photoURL, undefined, undefined);
            }).catch(err => {
                console.log(err);
            });
        } else {
            this.firestore.collection('connections').add({
                ...connect,
            }).then(() => {
                window.dispatchEvent(new CustomEvent('ledger-update', {
                    detail: { user: this.currentUser.id, message: 'Coins for Connection!', value: -1 }
                  }));
                this.presentToast('Connection Requested!');
                this.notificationsService.sendNotification(this.currentUser.displayName, 'Connection Requested', {
                    notificationToken: userAccount.notificationToken,
                    type: 'connection',
                    by: this.currentUser.id,
                    to: userAccount.id,
                    redirectURL: '/profile/' + this.currentUser.uid
                }, userAccount.photoURL, undefined, undefined);
            }).catch(err => {
                console.log(err);
            });
        }
    }

    async acceptConnection(connection, userAccount) {
        this.firestore.collection('connections').doc(connection.id).update({ status: 'accepted' }).then(() => {
            this.presentToast('You Have Accepted The Connection!');
            this.notificationsService.sendNotification(this.currentUser.displayName, 'Connection Accepted', {
                notificationToken: userAccount.notificationToken,
                type: 'notification',
                by: this.currentUser.id,
                to: userAccount.id,
                redirectURL: '/profile/' + this.currentUser.uid
            }, userAccount.photoURL, undefined, undefined);
        }).catch(err => {
            console.log(err);
        });
    }

    async disconnect(connection, userAccount) {
        this.firestore.collection('connections').doc(connection.id).delete().then(() => {
            this.presentToast('Connection Disconnected!');
            this.notificationsService.sendNotification(this.currentUser.displayName, 'Connection Disconnected', {
                notificationToken: userAccount.notificationToken,
                type: 'notification',
                by: this.currentUser.id,
                to: userAccount.id,
                redirectURL: '/profile/' + this.currentUser.uid
            }, userAccount.photoURL, undefined, undefined);
        }).catch(err => {
            console.log(err);
        });
    }

    closeConnects(userAccount) {
        this.firestore.collection('accounts').doc(userAccount.id).update({
            closeConnects: firebase.firestore.FieldValue.arrayUnion(this.currentUser.id)
        }).then(() => {
            this.presentToast(`You have made ${userAccount.displayName} a close Connection.`);
            this.notificationsService.sendNotification('Congratulations ' + this.currentUser.displayName, 'has made you their close connect', {
                notificationToken: userAccount.notificationToken,
                type: 'notification',
                by: this.currentUser.id,
                to: userAccount.id,
                redirectURL: '/profile/' + this.currentUser.uid
            }, userAccount.photoURL, undefined, undefined);
        }).catch(err => {
            console.log(err);
        });
    }

    closeDisconnects(userAccount) {
        this.firestore.collection('accounts').doc(userAccount.id).update({
            closeConnects: firebase.firestore.FieldValue.arrayRemove(this.currentUser.id)
        }).then(() => {
            this.presentToast(`You have removed ${userAccount.displayName} a close Connection.`);
            this.notificationsService.sendNotification('Congratulations ' + this.currentUser.displayName, 'has removed you from their close connect', {
                notificationToken: userAccount.notificationToken,
                type: 'notification',
                by: this.currentUser.id,
                to: userAccount.id,
                redirectURL: '/profile/' + this.currentUser.uid
            }, userAccount.photoURL, undefined, undefined);
        }).catch(err => {
            console.log(err);
        });
    }

    // Sign in with email/password
    signIn(email: string, password: string) {
        return this.auth.signInWithEmailAndPassword(email, password)
            .then((result) => {
                this.setUserData(result.user);
            })
            .catch((error) => {
                window.alert(error.message);
            });
    }
    // Sign up with email/password
    signUp(email: string, password: string) {
        return this.auth.createUserWithEmailAndPassword(email, password)
            .then((result) => {
                /* Call the SendVerificaitonMail() function when new user sign
                up and returns promise */
                this.setUserData(result.user);
            })
            .catch((error) => {
                window.alert(error.message);
            });
    }
    // Reset Forggot password
    forgotPassword(passwordResetEmail: string) {
        return this.auth.sendPasswordResetEmail(passwordResetEmail)
            .then(() => {
                window.alert('Password reset email sent, check your inbox.');
            })
            .catch((error) => {
                window.alert(error);
            });
    }
    /* Setting up user data when sign in with username/password,
    sign up with username/password and sign in with social auth
    provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
    async setUserData(user: any) {
        (await this.auth.currentUser)?.updateProfile({
            displayName: user?.displayName, photoURL: user?.photoURL
        }).then(() => {
            // Profile updated!
            // ...
        }).catch((error) => {
            // An error occurred
            // ...
        });
    }

    logout() {
        // Set logout flag to prevent re-authentication
        this.isLoggingOut = true;
        
        // Unsubscribe from user subscription to prevent re-setting localStorage
        if (this?.unsub1?.unsubscribe) {
            this.unsub1.unsubscribe();
        }
        
        // Clear all local data first
        localStorage.removeItem('currentUser');
        localStorage.removeItem('lastActiveTimestamp');
        localStorage.removeItem('status');
        localStorage.removeItem('registrationComplete');
        localStorage.removeItem('refCodeBy');
        
        // Reset service properties
        this.currentAccount.next(undefined);
        this.uid = undefined;
        this.id = undefined;
        this.currentUser = undefined;
        
        return this.auth.signOut().then(() => {
            // Navigate to login after successful signout
            this.navController.navigateRoot(['/login']);
            return true;
        }).catch((error) => {
            console.log(error);
            this.presentToast(error.message);
            this.isLoggingOut = false; // Reset flag on error
            return false;
        });
    }

    deleteAccount(id) {
        this.firestore.collection('accounts').doc(id).update({
            accountDelete: true
        }).then(() => {
            this.logout();
        });
    }

    async presentToast(message) {
        const toast = await this.toastController.create({
            message,
            duration: 3000,
            position: 'top',
        });
        toast.present();
    }
}
